const en = {
  code: "en",
  nav: { book: "Book now", whatsapp: "WhatsApp", menu: "Menu" },
  hero: {
    eyebrow: "Tenerife · South coast · Daily departures",
    lines: ["The best trips in Tenerife,", "booked in a minute."],
    sub: "Live availability, instant payment and your QR voucher in your inbox before you've put the phone down.",
    ctaBook: "Book online",
    ctaWa: "Message on WhatsApp",
    trust: ["Free cancellation", "Instant confirmation", "Voucher with QR code", "Secure card payment"],
    scroll: "Scroll",
  },
  marquee: ["Live availability", "Pay in under a minute", "QR voucher by email", "Free cancellation up to 24h", "Local crew, small groups", "Rated 4.9 by 2,300 guests"],
  trips: {
    eyebrow: "Today's trips",
    title: "Three trips. Real dates. No waiting.",
    sub: "Every date you see is genuinely free. Pick one, pay, and your voucher is on its way.",
    perPerson: "per person",
    duration: "Duration",
    departs: "Departs",
    included: "What's included",
    pickDate: "Pick a date",
    people: "People",
    total: "Total",
    pay: "Pay",
    payNow: "Pay & get voucher",
    free: "Free",
    few: "Few left",
    full: "Fully booked",
    spotsLeft: "spots left",
    selectDateFirst: "Choose a free date to continue",
    hours: "hours",
    meeting: "Meeting point",
    live: "Live availability",
    items: {
      jetski: {
        title: "Jet Ski Safari",
        tagline: "Two hours carving the south coast on your own jet ski, guided the whole way.",
        includes: ["Own jet ski (1–2 riders)", "Qualified guide & briefing", "Wetsuit, life jacket & lockers", "Photos of your ride"],
        meeting: "Puerto Colón, Pontoon 3",
      },
      catamaran: {
        title: "Whale & Dolphin Catamaran",
        tagline: "Three hours sailing with resident pilot whales, a swim stop and lunch on deck.",
        includes: ["Guaranteed whale sightings", "Lunch, drinks & fruit", "Swim & snorkel stop", "Hotel pickup in the south"],
        meeting: "Los Cristianos Harbour, Gate B",
      },
      teide: {
        title: "Teide Sunset & Stars",
        tagline: "Five hours above the clouds: sunset on the crater rim, then the sky under a Starlight guide.",
        includes: ["Air-conditioned minibus", "Astronomer guide & telescopes", "Hot chocolate & blanket", "Hotel pickup & drop-off"],
        meeting: "Pickup from your hotel",
      },
    },
  },
  payment: {
    title: "Secure checkout",
    sub: "Pay by card. Your voucher with QR code lands in your inbox the moment the payment goes through.",
    name: "Full name",
    email: "Email for the voucher",
    card: "Card number",
    expiry: "Expiry",
    cvc: "CVC",
    pay: "Pay",
    processing: "Confirming your date…",
    secure: "256-bit encrypted · Protected by 3-D Secure",
    demo: "Demo checkout — no card will be charged.",
    summary: "Order summary",
    error: "Something went wrong. Please try again.",
    dateGone: "That date just sold out. Please choose another.",
    freeCancel: "Free cancellation up to 24 hours before departure",
  },
  voucher: {
    eyebrow: "Payment confirmed",
    title: "You're booked.",
    sent: "Your voucher has been sent to",
    code: "Booking code",
    show: "Show this QR code at the meeting point",
    date: "Date",
    time: "Time",
    people: "People",
    paid: "Paid",
    meeting: "Meeting point",
    download: "Download voucher",
    done: "Done",
    bookAnother: "Book another trip",
  },
  how: {
    eyebrow: "How it works",
    title: "Three steps, one minute.",
    steps: [
      { t: "Pick a free date", d: "The calendar shows what's actually available today. If it's green, it's yours." },
      { t: "Pay by card", d: "Apple Pay, Google Pay or any card. Your spots are locked the second you pay." },
      { t: "Your voucher lands", d: "A voucher with QR code arrives by email straight away. Show it on your phone and go." },
    ],
  },
  reviews: {
    eyebrow: "Guest reviews",
    title: "What people say when they get back.",
    items: [
      { name: "Hannah Whitmore", place: "Manchester, UK", trip: "Jet Ski Safari", text: "Booked at breakfast, on the water by half ten. The voucher came through before I'd finished my coffee. The guide was brilliant and the photos are unreal." },
      { name: "Lukas Brandt", place: "Hamburg, Germany", trip: "Whale & Dolphin Catamaran", text: "We saw pilot whales within twenty minutes. Lunch on deck, swim stop in a quiet bay, no crowds. The QR check-in took about three seconds." },
      { name: "Chiara Moretti", place: "Milan, Italy", trip: "Teide Sunset & Stars", text: "The sunset above the clouds alone was worth it, then the stars. Our guide knew everything. Pickup was on time to the minute." },
    ],
    verified: "Verified booking",
  },
  faq: {
    eyebrow: "FAQ",
    title: "Good to know.",
    items: [
      { q: "What's included in the price?", a: "Everything listed on the trip card: equipment, guide, insurance and any food or pickup mentioned. There are no booking fees and no surprises at the meeting point." },
      { q: "Can I cancel or change my date?", a: "Yes. Cancel free of charge up to 24 hours before departure for a full refund, or move your booking to any other free date with a single message on WhatsApp." },
      { q: "What happens if the weather turns?", a: "Safety comes first. If the captain or guide calls off a trip for weather, you choose: a new date, a different trip, or a full refund the same day. You will never be out of pocket." },
      { q: "How do I use the QR voucher?", a: "Just show it on your phone at the meeting point. No printing, no paperwork. The crew scans it and you're on board." },
    ],
  },
  footer: {
    tagline: "Small-group excursions on Tenerife's south coast, run by the people who live here.",
    contact: "Contact",
    whatsapp: "Chat on WhatsApp",
    call: "Call us",
    email: "Email",
    payments: "We accept",
    hours: "Open every day 08:00 – 21:00",
    built: "Designed and built by",
    rights: "All rights reserved.",
    legal: "Licensed tour operator · Registered in Santa Cruz de Tenerife",
  },
  mobile: { from: "From", book: "Book now" },
};
export default en;
